import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=36713b07&scoped=true"
import script from "./DataDetail.vue?vue&type=script&lang=js"
export * from "./DataDetail.vue?vue&type=script&lang=js"
import style0 from "./DataDetail.vue?vue&type=style&index=0&id=36713b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36713b07",
  null
  
)

export default component.exports